"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateXForElement = translateXForElement;
/**
 * Function to read transform property on element.
 *
 * @param {HTMLElement} element The element to read attributes from
 * @returns {Number} Return New Position of Element
 */
function translateXForElement(element) {
  const transform = element.style.transform;
  const extractTranslateX = transform.match(/translate(?:X|3d)\((-?\d+)/);
  if (!extractTranslateX || extractTranslateX.length !== 2) {
    return 0;
  }
  return parseInt(extractTranslateX[1], 10);
}